var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.message))]),_c('h3',[_vm._v("You may now close this browser tab")])])
}
var staticRenderFns = []

export { render, staticRenderFns }